module.exports = __webpack_public_path__ + "static/banner-2b40c0d42f1f9bdcb364a65761068f9b.jpg";